import * as htmx from "htmx.org";

export function evaluateReadMores(content?: Element | Document | null | undefined) {
    if (!content) {
        content = document;
    }
    content.querySelectorAll<HTMLElement>("[data-read-more]").forEach(readmore => {
        if (readmore.clientHeight >= readmore.scrollHeight) {
            readmore.classList.remove("group-data-[expanded=false]:mask-b-from-0");
            readmore.classList.remove("group-data-[expanded=false]:h-30");
            readmore.nextElementSibling?.remove();
        }
    });
}

document.addEventListener('DOMContentLoaded', (event) => {
    evaluateReadMores(document);
});

htmx.on('htmx:afterSwap', (e) => {
    evaluateReadMores(e.target as Element);
});
